/**
 * The cycle workspace's index view (f10.3): the cycle calendar.
 *
 * The five milestones and their `WD<n>` tags come from the server's `derived`
 * block (adr-13). No mock figures: the stat cards, Business Unit progress and
 * activity arrive with phases 11 and 12 as cards on this same view.
 *
 * f12.3: the frozen banner above the calendar and the snapshot history below.
 */

import { CalendarDays } from 'lucide-react';

import { SubmissionCard } from '@/features/cycle-submission/SubmissionCard';

import { formatCycleDate, workingDayTag } from './cycleView';
import { useCycleWorkspace } from './CycleWorkspaceLayout';
import { FrozenBanner } from './freeze/FrozenBanner';
import { SnapshotHistoryCard } from './freeze/SnapshotHistoryCard';
import { MILESTONE_LABELS } from './workflowView';

export function CycleOverview() {
  const { cycle } = useCycleWorkspace();
  const { milestones, basis } = cycle.derived.calendar;

  return (
    <>
      <FrozenBanner
        stateCode={cycle.state.code}
        snapshot={cycle.current_snapshot}
        reopened={cycle.last_reopen !== null}
      />
      <SubmissionCard cycle={cycle} />
      <div className="card">
        <div className="card-head">
          <h3>Cycle calendar</h3>
          <span className="hint">{basis === 'MON_FRI_NO_HOLIDAYS' ? 'Mon–Fri working days' : basis}</span>
        </div>
        <div className="card-body">
          <ol className="cycle-calendar">
            {milestones.map((milestone) => (
              <li key={milestone.key} className="cycle-calendar-item">
                <span className="cycle-calendar-icon" aria-hidden="true">
                  <CalendarDays />
                </span>
                <span className="cycle-calendar-label">
                  {MILESTONE_LABELS[milestone.key] ?? milestone.key}
                </span>
                <span className="cycle-wd-tag">{workingDayTag(milestone)}</span>
                <span className="cycle-calendar-date mono">{formatCycleDate(milestone.date)}</span>
              </li>
            ))}
          </ol>
        </div>
      </div>
      <SnapshotHistoryCard cycle={cycle} />
    </>
  );
}
